import React from "react";
import { IonModal, IonIcon } from "@ionic/react";
import { closeOutline } from "ionicons/icons";

interface WebWarningContentProps {
  onClose: () => void;
  title: string;
  message: string;
  ctaText?: string;
  hideCloseButton?: boolean;
}

export const WebWarningContent: React.FC<WebWarningContentProps> = ({
  onClose,
  title,
  message,
  ctaText = "Close",
  hideCloseButton = false,
}) => {
  return (
    <div
      style={{
        background: "#ffffff",
        borderRadius: "24px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        height: "auto",
      }}
    >
      {/* Gradient Header */}
      <div
        style={{
          background: "linear-gradient(135deg, #01b7c4 0%, #00acd7 100%)",
          padding: "28px 28px 48px",
          position: "relative",
          textAlign: "center",
        }}
      >
        {!hideCloseButton && (
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.2)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(255,255,255,0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <IonIcon
              icon={closeOutline}
              style={{ color: "white", fontSize: "20px" }}
            />
          </button>
        )}
        <h2
          style={{
            fontSize: "22px",
            fontWeight: 700,
            color: "white",
            margin: 0,
            fontFamily: "Figtree, sans-serif",
          }}
        >
          {title}
        </h2>
      </div>

      {/* White body with curved top */}
      <div
        style={{
          background: "#ffffff",
          marginTop: "-20px",
          borderRadius: "24px 24px 0 0",
          padding: "28px 28px 32px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "24px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <p
          style={{
            fontSize: "15px",
            color: "#64748b",
            textAlign: "center",
            lineHeight: "1.6",
            margin: 0,
            fontFamily: "Figtree, sans-serif",
          }}
        >
          {message}
        </p>
        <button
          onClick={onClose}
          style={{
            width: "100%",
            padding: "14px",
            background: "linear-gradient(135deg, #01b7c4 0%, #00acd7 100%)",
            border: "none",
            borderRadius: "14px",
            color: "white",
            fontSize: "16px",
            fontWeight: 600,
            fontFamily: "Figtree, sans-serif",
            cursor: "pointer",
          }}
        >
          {ctaText}
        </button>
      </div>
    </div>
  );
};

// Full modal wrapper — use this when there is no existing modal in the parent
interface WebWarningModalProps extends WebWarningContentProps {
  isOpen: boolean;
}

const WebWarningModal: React.FC<WebWarningModalProps> = ({
  isOpen,
  ...rest
}) => {
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={rest.onClose}
      style={
        {
          "--width": "420px",
          "--max-width": "95vw",
          "--height": "auto",
          "--border-radius": "24px",
          "--backdrop-opacity": "0.5",
        } as React.CSSProperties
      }
    >
      <WebWarningContent {...rest} />
    </IonModal>
  );
};

export default WebWarningModal;
